var $8fc1e38f2f738334$exports = {};
$8fc1e38f2f738334$exports = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};


export {$8fc1e38f2f738334$exports as default};
//# sourceMappingURL=es-ES.mjs.map
